import { Youtube, Instagram, Facebook } from "lucide-react";
import { YOUTUBE_URL } from "@/data/content";

export const TikTokIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.6 6.2a5.1 5.1 0 0 1-3.6-3.5V2h-3.4v13.6a2.9 2.9 0 1 1-2-2.75V9.4a6.3 6.3 0 1 0 5.4 6.2V8.9a8.4 8.4 0 0 0 4.4 1.3V6.8c-.3 0-.5-.3-.8-.6z" />
  </svg>
);

export const SOCIALS = [
  { id: "youtube", label: "YouTube", href: YOUTUBE_URL, Icon: Youtube },
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/forethehellofit_", Icon: Instagram },
  { id: "tiktok", label: "TikTok", href: "https://www.tiktok.com/@forethehellofit", Icon: TikTokIcon },
  { id: "facebook", label: "Facebook", href: "https://www.facebook.com/share/1C5Wju49YJ/", Icon: Facebook },
];

export const SocialIconButtons = ({ exclude = [], testidPrefix = "social" }) => (
  <div className="flex gap-3">
    {SOCIALS.filter((s) => !exclude.includes(s.id)).map(({ id, href, label, Icon }) => (
      <a
        key={id}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        data-testid={`${testidPrefix}-${id}`}
        className="grid h-12 w-12 place-items-center border border-white/15 text-white/70 transition-colors duration-300 hover:border-brand-accent hover:text-brand-accent"
      >
        <Icon className="h-4 w-4" />
      </a>
    ))}
  </div>
);
